/**
 * IntroPriceBanner — prominente promo-pricing hoofding.
 *
 * Wordt bovenaan zowel de Quick Scan als de Demo Experience getoond
 * zodat de prijs-belofte (€ 9,95/m · eerste 3 maanden · daarna € 14,95/m
 * · maandelijks opzegbaar) altijd zichtbaar is. Geen € 19,95 claims.
 *
 * Variant 'pill' = compacte pill bovenaan een sectie.
 * Variant 'hero' = grotere banner direct boven de hoofding van een pagina.
 */
import { Sparkles } from 'lucide-react';

export default function IntroPriceBanner({
  variant = 'pill',
  className = '',
  testId = 'intro-price-banner',
}) {
  if (variant === 'hero') {
    return (
      <div
        className={[
          'rounded-2xl border-2 border-primary/30 bg-gradient-to-r from-primary/10 via-primary/5 to-background',
          'px-4 py-3 sm:px-5 sm:py-3.5 mb-5',
          className,
        ].join(' ')}
        data-testid={testId}
      >
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-primary text-primary-foreground shadow-sm">
            <Sparkles className="w-4 h-4" />
          </span>
          <div className="flex-1 min-w-0">
            <p
              className="text-sm sm:text-base font-semibold text-primary leading-tight"
              style={{ fontFamily: 'Outfit' }}
            >
              € 9,95 per maand · eerste 3 maanden, daarna € 14,95 per maand · maandelijks opzegbaar
            </p>
            <p className="text-[12px] text-foreground/75 mt-0.5 leading-snug">
              Eerst gratis inzicht · geen leverancierswissel · geen verplicht adviesgesprek
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Default pill variant — compact, sits above any heading.
  return (
    <div
      className={[
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full',
        'bg-primary/10 border border-primary/20 text-primary text-[12px] font-semibold',
        className,
      ].join(' ')}
      data-testid={testId}
    >
      <Sparkles className="w-3 h-3" />
      € 9,95/m · eerste 3 mnd · daarna € 14,95/m · opzegbaar
    </div>
  );
}
